import { Button } from '@mui/material'
import { FC, useCallback, useState } from 'react'
import { InformationModal } from 'utoniq-ui'

import { useMessage, useTranslation } from '@/core'
import { captureError } from '@/core/errors'

import { Action } from './../'

type CancelPlanButtonProps = {
  type: string
  artistId: string
  stoppingSubscription: boolean
  onStopSubscription: Action['onStopSubscription']
}

export const CancelPlanButton: FC<CancelPlanButtonProps> = ({
  type,
  artistId,
  stoppingSubscription,
  onStopSubscription,
}) => {
  const { t } = useTranslation('membership')
  const { showMessage, showError } = useMessage()
  const [openConfirm, setOpenConfirm] = useState<boolean>(false)

  const handleStopSubscription = useCallback(async () => {
    return onStopSubscription(artistId)
      .then(() => showMessage(t('complete')))
      .catch(e => {
        captureError(e, 'MembershipTemplate')
        showError(new Error(t('error')))
      })
      .finally(() => setOpenConfirm(false))
  }, [artistId, onStopSubscription, showError, showMessage, t])

  if (type !== 'stripe' && type !== 'escott') {
    return null
  }

  return (
    <>
      <Button
        size="large"
        variant="outlined"
        color="inherit"
        sx={{ width: 240 }}
        onClick={() => setOpenConfirm(true)}
      >
        {t('cancelUpdate')}
      </Button>

      <InformationModal
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        title={t('confirm')}
        content={t('confirmContent')}
        cancelText={t('cancel')}
        buttons={
          <Button
            size="large"
            sx={{ minWidth: 212 }}
            onClick={handleStopSubscription}
            loading={stoppingSubscription}
            disabled={stoppingSubscription}
          >
            {t('stopSubscription')}
          </Button>
        }
      />
    </>
  )
}
